<template>
  <aside class="sidebar-menu pt-10">
    <div class="sidebar-menu__nav">
      <SidebarMenuNav
        :menu="menu"
        @updateCurrent="current = $event"
      ></SidebarMenuNav>
    </div>
  </aside>
</template>

<script>
/** Components */
import SidebarMenuNav from '@/components/SidebarMenuNav.vue'

/** Data */
import Menu from '../../data/static/menu.js'

export default {
  name: 'SideBarMenu',

  components: {
    SidebarMenuNav,
  },

  data() {
    return {
      current: null,
    }
  },

  computed: {
    menu() {
      return Menu
    },
  },
}
</script>

<style lang="scss" scoped></style>
